import React from 'react'
import PageShell from '../PageShell'
import ErrorContent from './ErrorContent'

const ErrorPage = () => (
    <PageShell
        title="Page Not Found"
        blurb="Looks like the page can't be found. That's odd."
        img={require('assets/img/error-bg.jpg')}
        components={[<ErrorContent key={0} />]}
    />
)

export default ErrorPage



// WEBPACK FOOTER //
// ./src/views/ErrorPage/ErrorPage.jsx